import {createSvgIcon} from '../create-svg-icon';

export const CalendarViewDayIcon = createSvgIcon(
  <path d="M3 17h18v2H3zm16-5v1H5v-1h14m2-2H3v5h18v-5zM3 6h18v2H3z" />
, 'CalendarViewDayOutlined');
